import { Modal, ModalProps } from '../../../../../ui/components/pure/modal/modal.component';
import { BookOrderStep } from './book-order-step/book-order-step.component';
import { BookOrderActionContextProvider, useBookOrderActionContext } from './book-order-action.context';
import { FindCustomerStep } from './find-customer-step/find-customer-step.component';
import { BookOrderActionProps } from './book-order-action.hook';
import { DeliverNowStep } from './book-order-step/deliver-now-step.component';
import { BookingProgressStep } from './book-order-step/booking-progress-step.component';
import { BookingCompletedStep } from './book-order-step/booking-completed-step.component';

export function BookOrderAction(props: BookOrderActionProps) {
  return (
    <BookOrderActionContextProvider {...props}>
      <BookOrderActionModal />
    </BookOrderActionContextProvider>
  );
}

function BookOrderActionModal() {
  const { state, handlers } = useBookOrderActionContext();
  let modalTitle = 'Book Order';
  let maxWidth: ModalProps['maxWidth'] = 'md';

  let content: JSX.Element | null = null;

  if (state.current === 'FIND_CUSTOMER') {
    content = <FindCustomerStep />;
  }

  if (state.current === 'BOOK_ORDER') {
    content = <BookOrderStep />;
  }

  if (state.current === 'DELIVER_NOW') {
    content = (
      <DeliverNowStep
        order={state.order}
        onComplete={handlers.onCompleteDeliverNow}
        onAbort={handlers.onCancelDeliverNow}
      />
    );
    modalTitle = 'Deliver Now';
    maxWidth = 'xs';
  }

  if (state.current === 'BOOKING_IN_PROGRESS') {
    content = <BookingProgressStep />;
  }

  if (state.current === 'BOOKING_COMPLETED') {
    content = <BookingCompletedStep />;
    modalTitle = 'Order Booked';
  }

  // If we are in progress step, then the component has it's own spinner.
  const modalLoading = state.loading && state.current !== 'BOOKING_IN_PROGRESS';

  return (
    <Modal title={modalTitle} open={true} maxWidth={maxWidth} loading={modalLoading} onClose={handlers.onCancelIntent}>
      {content}
    </Modal>
  );
}
